import React, { useState } from 'react';

export default function useToggle(initialValue = false) {
  const [toggle, setToggle] = useState(initialValue);
  const handleToggle = () => setToggle((value) => !value);
  return [toggle, handleToggle];
}
